export default "__VITE_ASSET__2f7c9261__"